var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractiveEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 99,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#343665",
    d: "m3.80908,24.1038l-3.13881,0l0,-23.77719l3.13881,0l0,23.77719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#343665",
    d: "m27.857,24.1038l-3.1552,0l-11.9831,-18.32281l0,18.32281l-3.15513,0l0,-23.77719l3.15513,0l12.0158,18.40449l0,-18.40449l3.1225,0l0,23.77719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#343665",
    d: "m49.3873,2.90682l-7.6509,0l0,21.19698l-3.1224,0l0,-21.19698l-7.6346,0l0,-2.58021l18.4079,0l0,2.58021z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#343665",
    d: "m66.3728,13.1134l-10.3155,0l0,8.4265l11.983,0l0,2.5639l-15.1219,0l0,-23.77719l14.9585,0l0,2.58021l-11.8196,0l0,7.64268l10.3155,0l0,2.5639z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#343665",
    d: "m80.6773,14.4851l-5.591,0l0,9.6187l-3.1551,0l0,-23.77719l7.8797,0c2.6811,0 4.7409,0.60967 6.1795,1.82901c1.4495,1.21934 2.1743,2.99392 2.1743,5.32374c0,1.48063 -0.4032,2.77074 -1.2097,3.87034c-0.7956,1.0996 -1.9073,1.9215 -3.335,2.4659l5.591,10.0922l0,0.196l-3.3677,0l-5.166,-9.6187zm-5.591,-2.5639l4.8227,0c1.5585,0 2.7955,-0.4028 3.711,-1.2084c0.9264,-0.80565 1.3895,-1.88346 1.3895,-3.23344c0,-1.46975 -0.4413,-2.59655 -1.3241,-3.38041c-0.8719,-0.78386 -2.1362,-1.18124 -3.7928,-1.19213l-4.8063,0l0,9.01438z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#343665",
    d: "m105.722,17.8982l-9.9718,0l-2.2397,6.2056l-3.2369,0l9.0895,-23.77719l2.7469,0l9.105,23.77719l-3.22,0l-2.273,-6.2056zm-9.0236,-2.5802l8.0926,0l-4.055,-11.12107l-4.0376,11.12107z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#343665",
    d: "m131.732,16.5591c-0.294,2.5149 -1.226,4.4582 -2.795,5.83c-1.559,1.3609 -3.635,2.0413 -6.229,2.0413c-2.812,0 -5.068,-1.0071 -6.768,-3.0211c-1.689,-2.0141 -2.534,-4.7087 -2.534,-8.0836l0,-2.2863c0,-2.21006 0.392,-4.15338 1.177,-5.82998c0.796,-1.67659 1.918,-2.96126 3.368,-3.85399c1.449,-0.90362 3.128,-1.35543 5.035,-1.35543c2.528,0 4.556,0.70765 6.081,2.12296c1.526,1.40442 2.414,3.35319 2.665,5.84631l-3.155,0c-0.273,-1.89433 -0.867,-3.26609 -1.782,-4.11528c-0.905,-0.84918 -2.174,-1.27378 -3.809,-1.27378c-2.005,0 -3.58,0.74032 -4.725,2.22095c-1.133,1.48063 -1.7,3.58726 -1.7,6.31994l0,2.3025c0,2.5803 0.54,4.6325 1.619,6.1566c1.079,1.5242 2.588,2.2863 4.528,2.2863c1.744,0 3.079,-0.3919 4.005,-1.1758c0.938,-0.7947 1.559,-2.1719 1.864,-4.1316l3.155,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#343665",
    d: "m151.987,2.90682l-7.651,0l0,21.19698l-3.122,0l0,-21.19698l-7.635,0l0,-2.58021l18.408,0l0,2.58021z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#343665",
    d: "m158.886,24.1038l-3.139,0l0,-23.77719l3.139,0l0,23.77719z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#343665",
    d: "m172.52,19.9395l6.801,-19.61289l3.433,0l-8.828,23.77719l-2.779,0l-8.811,-23.77719l3.416,0l6.768,19.61289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#343665",
    d: "m199.413,13.1134l-10.316,0l0,8.4265l11.983,0l0,2.5639l-15.122,0l0,-23.77719l14.959,0l0,2.58021l-11.82,0l0,7.64268l10.316,0l0,2.5639z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#343665",
    d: "m34.597,69.8991l-26.52576,0l0,21.6682l30.81366,0l0,6.5928l-38.8849,0l0,-61.1412l38.4645,0l0,6.6348l-30.39326,0l0,19.6525l26.52576,0l0,6.5929z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#343665",
    d: "m154.146708,90.1395c-2.0739,2.9675 -4.9745,5.1931 -8.7018,6.6769c-3.6993,1.4557 -8.0152,2.1836 -12.9476,2.1836c-4.9885,0 -9.4165,-1.1618 -13.2839,-3.4854c-3.8675,-2.3516 -6.8662,-5.683 -8.9961,-9.9942c-2.1019,-4.3113 -3.1809,-9.3084 -3.2369,-14.9914l0,-5.3331c0,-9.2104 2.1439,-16.3491 6.4318,-21.4162c4.3158,-5.0671 10.3693,-7.6007 18.1602,-7.6007c6.3898,0 11.5324,1.6377 15.4279,4.9131c3.8955,3.2475 6.2776,7.8667 7.1464,13.8576l-8.0713,0c-1.5133,-8.0906 -6.3336,-12.1359 -14.4609,-12.1359c-5.4089,0 -9.5145,1.9037 -12.3171,5.711c-2.7744,3.7794 -4.1757,9.2664 -4.2037,16.4612l0,4.9971c0,6.8588 1.5694,12.3178 4.7082,16.3771c3.1388,4.0313 7.3846,6.047 12.7374,6.047c3.0267,0 5.6751,-0.336 7.9451,-1.0079c2.2701,-0.6719 4.1477,-1.8057 5.6331,-3.4014l0,-13.7316l-14.1667,0l0,-6.5508l22.1959,0l0,22.424z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#343665",
    d: "m52.046897,98.1601l0,-61.1412l17.278,0c5.325,0 10.033,1.1757 14.125,3.5273c4.091,2.3516 7.244,5.697 9.458,10.0363c2.242,4.3392 3.377,9.3223 3.405,14.9494l0,3.9053c0,5.767 -1.121,10.8201 -3.363,15.1593c-2.214,4.3393 -5.395,7.6707 -9.542,9.9943c-4.12,2.3236 -8.926,3.5134 -14.419,3.5693l-16.942,0zm8.072,-54.5064l0,47.9136l8.491,0c6.222,0 11.056,-1.9317 14.503,-5.795c3.475,-3.8633 5.213,-9.3643 5.213,-16.5031l0,-3.5694c0,-6.9428 -1.639,-12.3318 -4.918,-16.1671c-3.251,-3.8634 -7.875,-5.823 -13.873,-5.879l-9.416,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#343665",
    d: "m198.712,69.8991l-26.526,0l0,21.6682l30.814,0l0,6.5928l-38.885,0l0,-61.1412l38.465,0l0,6.6348l-30.394,0l0,19.6525l26.526,0l0,6.5929z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveEdge);
export default __webpack_public_path__ + "static/media/interactiveEdge.432efae74999b92d9f7b99c2b31ccfb9.svg";
export { ForwardRef as ReactComponent };